export type ContentFilterType = "snapshot" | "recording" | "document" | "conversation" | "project" | "customer";

export const ContentFilterMapping: Record<ContentFilterType, string> = {
	snapshot: "Photos",
	recording: "Videos",
	document: "Documents",
	conversation: "My Stuff / Sessions",
	project: "Projects",
	customer: "Contacts"
};
